/**
 * This is probably not the entire list of schemas,
 * I added what I could see here and we likely need to add more
 */
/* istanbul ignore next */
var UserProfileSchema;
(function (UserProfileSchema) {
    UserProfileSchema["Core"] = "urn:scim:schemas:core:1.0";
    UserProfileSchema["Enterprise"] = "urn:scim:schemas:extension:enterprise:1.0";
    UserProfileSchema["GetGo"] = "urn:scim:schemas:extension:getgo:1.0";
    UserProfileSchema["Jive"] = "urn:scim:schemas:extension:jive:1.0";
})(UserProfileSchema || (UserProfileSchema = {}));

export { UserProfileSchema };
